module.exports = __webpack_public_path__ + "static/media/CTLA_9-383w.81795f53.jpg";